import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { S25TableModule } from "../../s25-table/s25.table.module";
import { S25ModalModule } from "../../s25-modal/s25.modal.module";
import { S25DatepickerModule } from "../../s25-datepicker/s25.datepicker.module";
import { S25EditableModule } from "../../s25-editable/s25.editable.module";
import { S25CheckboxModule } from "../../s25-checkbox/s25.checkbox.module";
import { S25SpecialDateManagementListComponent } from "./s25.special.date.management.list.component";
import { S25EditSpecialDateComponent } from "./s25.edit.special.date.component";
import { S25SpecialDateBulkUploadComponent } from "./s25.special.date.bulk.upload.component";
import { SpreadsheetModule } from "../../s25-spreadsheet/s25.spreadsheet.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        S25TableModule,
        S25ModalModule,
        S25DatepickerModule,
        S25EditableModule,
        S25CheckboxModule,
        SpreadsheetModule,
    ],
    exports: [S25SpecialDateManagementListComponent, S25EditSpecialDateComponent, S25SpecialDateBulkUploadComponent],
    declarations: [
        S25SpecialDateManagementListComponent,
        S25EditSpecialDateComponent,
        S25SpecialDateBulkUploadComponent,
    ],
})
export class S25SpecialDateManagementModule {}
